import React, { Component, Fragment } from 'react';
import { Field, reduxForm } from 'redux-form';
import moment from 'moment';

import Button from './../Inputs/Button';
import i18n from '../../../i18n/i18n.js';

const Unsubscribe = props => {
    const lng = props.lng;

    return (
        <Fragment>
            <form onSubmit={props.handleSubmit}>
                <section id="ipx-maincontent" className="gdpr-text">
                    <div className="headline" style={{ marginBottom: '30px' }}>
                        <h4>{i18n.t('cancel_subscription', { lng })}</h4>
                    </div>
                    <h2>{i18n.t('cancel_subscription_header', { lng })}</h2>
                    <div className="gdpr-inside">
                        <p>
                            {i18n.t('cancel_subscription_paragraph_first', {
                                lng,
                            })}{' '}
                            {`"${props.modal.title}"`}.{' '}
                            {i18n.t('cancel_subscription_paragraph_second', {
                                lng,
                            })}{' '}
                            {moment(props.modal.endDate * 1000)
                                .utc()
                                .format('D MMM YYYY HH:mm')}{' '}
                            (UTC) .
                        </p>
                    </div>
                    <div className="buttonholder buttonholder-gdpr">
                        <a href="#" onClick={props.back} className="back">
                            〈 BACK
                        </a>
                        <Button
                            text={i18n.t('cancel_subscription_confirm', {
                                lng,
                            })}
                            backgroundColor={
                                props.branding.paywall_buttons_bg_color
                            }
                            touched={props.params && props.params.anyTouched}
                            errors={
                                props.params && props.params.syncErrors
                                    ? true
                                    : false
                            }
                            isLoading={props.isLoading}
                        />
                    </div>
                </section>
            </form>
        </Fragment>
    );
};

export default reduxForm({
    form: 'unsubscribeForm',
    initialValues: {
        props: [{}],
    },
})(Unsubscribe);



// WEBPACK FOOTER //
// ./src/ui/components/Forms/Unsubscribe.js